export default __webpack_public_path__ + "static/media/elements.82d78ac0.png";